<se-fe-button seFeDataEmphasis="low" (click)="open($event.currentTarget)">Choose bundles</se-fe-button>

<se-fe-modal #modal seFeDataSize="large" seFeDataTitle="Choose bundles" (seFeAfterClose)="modalClosed()">
  <se-fe-modal-content>
    @if (error(); as loadError) {
      <se-fe-alert seFeDataType="error">{{ loadError.message }}</se-fe-alert>
    }

    <product-table
      mode="catalogBundle"
      linkPrefix="../../bundles/"
      [products]="bundles()"
      [loading]="loading()"
      [paginationOptions]="paginationOptions()"
      [query]="query()"
      [selectable]="true"
      [selectedRowIds]="selectedBundleIds()"
      [paginationEnabled]="true"
      [showSearch]="true"
      [showToolbarFilters]="false"
      [showNoResultsEmptyState]="true"
      [sortBy]="sortBy()"
      [sortDirection]="sortDirection()"
      (queryChanged)="queryChanged($event)"
      (selectionChanged)="selectionChanged($event)"></product-table>

    @if (saveError(); as addError) {
      <se-fe-alert seFeDataType="error">{{ addError.message }}</se-fe-alert>
    }

    <div class="catalog-bundle-chooser__footer">
      @if (selectedCount() > 0) {
        <span class="catalog-bundle-chooser__selection-count">{{ selectedCount() }} selected</span>
      }
      <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="saving()" (click)="close()">Cancel</se-fe-button>
      <se-fe-button
        seFeDataEmphasis="high"
        [seFeDataIsDisabled]="selectedCount() === 0 || saving()"
        [seFeDataIsLoading]="saving()"
        seFeDataLoadingLabel="Adding bundles"
        (click)="addSelectedBundles()">
        Add bundles
      </se-fe-button>
    </div>
  </se-fe-modal-content>
</se-fe-modal>
